module.exports = __webpack_public_path__ + "static/media/thumbs_down.3f12f48d.png";